<h2 class="fw-bold f-size-24 mb-4">პაროლის შეცვლა</h2>
<app-custom-foldable
  (isComponentClosed)="isComponentClosed($event)"
  [isComponentOpen]="isComponentOpen"
  [changeable]="true"
  title="პაროლი"
>
  <p header class="f-size-18">პაროლი</p>
  <form body [formGroup]="form" class="col-lg-6 px-0" (ngSubmit)="onSubmit()">
    <div class="position-relative form-group">
      <input
        appFormErrorMsg
        formControlName="old_password"
        class="form-control change-password__input"
        placeholder="მიმდინარე პაროლი"
        [type]="currentPasswordInputType"
      />
      <span
        class="position-absolute change-password__img"
        (click)="changeCurrentPassowrdInputType()"
        ><img src="assets/images/eye.svg" alt="eye"
      /></span>
    </div>
    <div class="position-relative form-group">
      <input
        appFormErrorMsg
        formControlName="password"
        class="form-control change-password__input"
        placeholder="ახალი პაროლი"
        [type]="newPasswordInputType"
      />
      <span
        class="position-absolute change-password__img"
        (click)="changeNewPassowrdInputType()"
        ><img src="assets/images/eye.svg" alt="eye"
      /></span>
    </div>
    <div class="position-relative form-group">
      <input
        appFormErrorMsg
        formControlName="password_confirmation"
        class="form-control change-password__input"
        placeholder="გაიმეორეთ პაროლი"
        [type]="confirmNewPasswordInputType"
      />
      <span
        class="position-absolute change-password__img"
        (click)="changeConfirmNewPassowrdInputType()"
        ><img src="assets/images/eye.svg" alt="eye"
      /></span>
    </div>
    <div>
      <button
        class="btn btn-primary fw-SemiBold f-size-16 p-3 bg-vibrant-blue"
        type="submit"
        [disabled]="!form.valid"
      >
        პაროლის განახლება
      </button>
    </div>
  </form>
</app-custom-foldable>
